import LinkObject from "@/domain/entities/emails/LinkObject";
import { LinkObject as LinkObjectSDK } from "@cs_teamwaydev/mailvista-sdk_react";

const linkObjectMapper = (link: LinkObjectSDK): LinkObject =>
    new LinkObject({
        url: link.url,
        name: link.name,
    });

export default linkObjectMapper;
